import React, { useState, useEffect } from "react";
import { Table, Input, Button, Header } from "semantic-ui-react";
import { Formik, Field, ErrorMessage, Form } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useAuth } from "../../../../hook/userAuth";
import { BASE_API } from "../../../../ruta-server/BaseApi";
import "./TableListaACursos.css";
import { ToastContainer, toast } from "react-toastify";
import ExcelJS from "exceljs"; // Importa la librería ExcelJS
import { saveAs } from "file-saver";

export function TableListaACursos(props) {
  const { datosCurso, alumnosCali, numero_unidades, onRefetch } = props;
  const [fecha_inicio, SetFecha_inicio] = useState(null);
  const [fecha_fin, SetFecha_fin] = useState(null);
  const { auth } = useAuth();
  const [refetch, setRefetch] = useState(false);
  const currentDate = new Date(); // Obtener la fecha y hora actual

  async function getCurso() {
    try {
      const response = await axios.get(
        `${BASE_API}/api/curso/${datosCurso.id}/`,
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      );

      const cursosData = response.data;
      SetFecha_inicio(cursosData.periodo_data.fecha_inicio);
      SetFecha_fin(cursosData.periodo_data.fecha_fin);
      return cursosData;
    } catch (error) {
      window.location.reload();
      window.location.href = "/Login";
    }
  }

  useEffect(() => {
    getCurso();
    // eslint-disable-next-line
  }, [refetch]);

  const dentroPeriodo =
    currentDate >= new Date(fecha_inicio) && currentDate <= new Date(fecha_fin);

  const unidadesArray = Array.from(
    { length: numero_unidades },
    (_, index) => index + 1
  );

  const actualizarCalificacionesAlumno = async (id, data) => {
    try {
      const url = `${BASE_API}/api/calificacion_curso/${id}/`;
      const headers = {
        Authorization: `Bearer ${auth.token}`,
        "Content-Type": "application/json",
      };
      const response = await axios.patch(url, data, { headers });

      onRefetch();
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  const generateExcel = async () => {
    try {
      const excelTemplateResponse = await axios.get(
        `${BASE_API}/api/lista-grupo-template/`,
        {
          responseType: "arraybuffer",
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      );
      const excelData = excelTemplateResponse.data;

      // Crear un nuevo libro de Excel
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(excelData);

      // Obtener la hoja de trabajo
      const worksheet = workbook.getWorksheet("lista_grupo");

      // Crear un nuevo arreglo de nombres
      const nombresAlumnos = alumnosCali.map((alumno) =>
        `${alumno.alumno_data.apellido_paterno} ${alumno.alumno_data.apellido_materno} ${alumno.alumno_data.nombre}`.toUpperCase()
      );

      // Asignar datos de grupo y periodo
      worksheet.getCell("AG1").value = datosCurso.grupo_data.numero_grupo;

      // Asignar datos del ciclo
      const fechaInicio = new Date(
        datosCurso.periodo_data.ciclo_escolar_data.fecha_inicio
      );
      const fechaFin = new Date(
        datosCurso.periodo_data.ciclo_escolar_data.fecha_fin
      );
      const cicloEscolar = `${fechaInicio.getFullYear()}-${fechaFin.getFullYear()}`;
      worksheet.getCell("D1").value = cicloEscolar;

      // Asignar grado y semestre
      const grupo = parseInt(datosCurso.grupo_data.numero_grupo, 10);
      if (grupo >= 100 && grupo < 200) {
        worksheet.getCell("H1").value = "1°";
        worksheet.getCell("R1").value = "I-II";
      } else if (grupo >= 200 && grupo < 300) {
        worksheet.getCell("H1").value = "2°";
        worksheet.getCell("R1").value = "III-IV";
      } else if (grupo >= 300 && grupo < 400) {
        worksheet.getCell("H1").value = "3°";
        worksheet.getCell("R1").value = "V-VI";
      } else if (grupo >= 400) {
        worksheet.getCell("H1").value = "4°";
        worksheet.getCell("R1").value = "VII-VIII";
      }

      // Llenar las celdas desde B5 hasta B36 con los nombres de los alumnos
      const startRow = 5;
      const endRow = 35;
      for (let i = startRow; i <= endRow; i++) {
        const cell = worksheet.getCell(`B${i}`);
        const alumnoIndex = i - startRow;
        cell.value = nombresAlumnos[alumnoIndex] || ""; // Asigna el nombre del alumno o deja la celda en blanco
      }

      // Guardar el libro de Excel
      const excelBuffer = await workbook.xlsx.writeBuffer();
      saveAs(
        new Blob([excelBuffer]),
        `Lista grupo ${datosCurso.grupo_data.numero_grupo}.xlsx`
      );
    } catch (error) {
      console.error("Error al generar el archivo Excel:", error);
      toast.error("Error al generar el archivo Excel");
    }
  };

  const formatDate = (dateString) => {
    const months = [
      "enero",
      "febrero",
      "marzo",
      "abril",
      "mayo",
      "junio",
      "julio",
      "agosto",
      "septiembre",
      "octubre",
      "noviembre",
      "diciembre",
    ];

    const date = new Date(dateString);
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${day} de ${month} del ${year}`;
  };

  return (
    <div>
      {alumnosCali?.length > 0 && (
        <Button
          icon="file excel"
          content="Lista de grupo"
          onClick={generateExcel}
        />
      )}
      <div style={{ textAlign: "center", margin: "20px 0" }}>
        <Header as="h4" color="red">
          {currentDate < new Date(fecha_inicio) && (
            <span>
              La fecha para capturar las calificaciones para este curso en este
              período aún no inicia. Podrá registrar las calificaciones a partir
              del {formatDate(fecha_inicio)}.
            </span>
          )}
          {currentDate > new Date(fecha_fin) && (
            <span>
              La fecha para capturar las calificaciones de este curso para este
              período ya ha terminado. El registro estuvo disponible hasta el{" "}
              {formatDate(fecha_fin)}.
            </span>
          )}
          {currentDate >= new Date(fecha_inicio) &&
            currentDate <= new Date(fecha_fin) && (
              <span>
                Puede registrar las calificaciones a partir del{" "}
                {formatDate(fecha_inicio)} y hasta el {formatDate(fecha_fin)}.
              </span>
            )}
        </Header>
      </div>

      <Formik
        initialValues={{
          calificaciones: alumnosCali.map((alumno) =>
            unidadesArray.reduce((acc, numero) => {
              acc[`calificacion_parcial_${numero}`] =
                alumno[`calificacion_parcial_${numero}`] !== null
                  ? Math.round(alumno[`calificacion_parcial_${numero}`])
                  : null;
              return acc;
            }, {})
          ),
          calificacion_final: alumnosCali.map((alumno) =>
            alumno.calificacion_final !== null
              ? Math.round(alumno.calificacion_final)
              : null
          ),
          porcentaje_asistencia: alumnosCali.map((alumno) =>
            alumno.porcentaje_asistencia !== null
              ? alumno.porcentaje_asistencia
              : null
          ),
        }}
        validationSchema={Yup.object().shape({
          calificaciones: Yup.array().of(
            Yup.object().shape(
              unidadesArray.reduce((acc, numero) => {
                acc[`calificacion_parcial_${numero}`] = Yup.number()
                  .nullable()
                  .integer("Debe ser un número entero")
                  .min(5, "La calificación debe ser igual o mayor a 5")
                  .max(10, "La calificación máxima es igual o menor a 10");
                return acc;
              }, {})
            )
          ),
          calificacion_final: Yup.array().of(
            Yup.number()
              .nullable()
              .integer("Debe ser un número entero")
              .min(5, "La calificación debe ser igual o mayor a 5")
              .max(10, "La calificación máxima es igual o menor a 10")
          ),
          porcentaje_asistencia: Yup.array().of(
            Yup.number()
              .nullable()
              .integer("Debe ser un número entero")
              .min(0, "El porcentaje de asistencia debe ser igual o mayor a 0")
              .max(100, "El porcentaje de asistencia máximo es 100")
          ),
        })}
        onSubmit={async (values, { setSubmitting }) => {
          setSubmitting(true);
          try {
            await Promise.all(
              alumnosCali.map(async (alumno, index) => {
                await actualizarCalificacionesAlumno(alumno.id, {
                  ...values.calificaciones[index],
                  calificacion_final: values.calificacion_final[index],
                  porcentaje_asistencia: values.porcentaje_asistencia[index],
                });
              })
            );
            toast.success("Calificaciones guardadas correctamente");
          } catch (error) {
            console.error("Error al guardar las calificaciones:", error);
          }
          setSubmitting(false);
        }}
      >
        {({ values, handleSubmit, isSubmitting, setFieldValue }) => (
          <Form onSubmit={handleSubmit}>
            <Table>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>NUM. DE LISTA</Table.HeaderCell>
                  <Table.HeaderCell>NOMBRES</Table.HeaderCell>
                  {unidadesArray.map((numero) => (
                    <Table.HeaderCell key={numero}>U {numero}</Table.HeaderCell>
                  ))}
                  <Table.HeaderCell>E. FINAL</Table.HeaderCell>
                  <Table.HeaderCell>% ASISTENCIA</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {alumnosCali.map((alumno, index) => {
                  const calificacionesLlenas = unidadesArray.every(
                    (numero) =>
                      values.calificaciones[index][
                        `calificacion_parcial_${numero}`
                      ] !== ""
                  );

                  return (
                    <Table.Row key={index}>
                      <Table.Cell>{index + 1}</Table.Cell>
                      <Table.Cell>
                        {`${alumno.alumno_data.apellido_paterno} ${alumno.alumno_data.apellido_materno} ${alumno.alumno_data.nombre}`}
                      </Table.Cell>
                      {unidadesArray.map((numero) => (
                        <Table.Cell key={numero}>
                          <Field
                            as={Input}
                            name={`calificaciones[${index}].calificacion_parcial_${numero}`}
                            value={
                              values.calificaciones[index][
                                `calificacion_parcial_${numero}`
                              ] || ""
                            }
                            onChange={(e) =>
                              setFieldValue(
                                `calificaciones[${index}].calificacion_parcial_${numero}`,
                                e.target.value
                                  ? Math.round(e.target.value)
                                  : null
                              )
                            }
                            type="number"
                            step="1"
                            min="5"
                            max="10"
                          />
                          <ErrorMessage
                            name={`calificaciones.${index}.calificacion_parcial_${numero}`}
                          >
                            {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                          </ErrorMessage>
                        </Table.Cell>
                      ))}
                      <Table.Cell>
                        <Field
                          as={Input}
                          name={`calificacion_final[${index}]`}
                          value={values.calificacion_final[index] || ""}
                          onChange={(e) =>
                            setFieldValue(
                              `calificacion_final[${index}]`,
                              e.target.value ? Math.round(e.target.value) : null
                            )
                          }
                          type="number"
                          step="1"
                          min="5"
                          max="10"
                          disabled={!calificacionesLlenas}
                        />
                        <ErrorMessage name={`calificacion_final.${index}`}>
                          {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                        </ErrorMessage>
                      </Table.Cell>
                      <Table.Cell>
                        <Field
                          as={Input}
                          name={`porcentaje_asistencia[${index}]`}
                          value={values.porcentaje_asistencia[index] || ""}
                          onChange={(e) =>
                            setFieldValue(
                              `porcentaje_asistencia[${index}]`,
                              e.target.value ? Math.round(e.target.value) : null
                            )
                          }
                          type="number"
                          step="1"
                          min="0"
                          max="100"
                        />
                        <ErrorMessage name={`porcentaje_asistencia.${index}`}>
                          {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                        </ErrorMessage>
                      </Table.Cell>
                    </Table.Row>
                  );
                })}
              </Table.Body>
            </Table>
            <div style={{ textAlign: "center", marginTop: "10px" }}>
              <Button
                type="submit"
                className="botonEnviar"
                disabled={isSubmitting || !dentroPeriodo}
              >
                Guardar
              </Button>
            </div>
          </Form>
        )}
      </Formik>
      <ToastContainer />
    </div>
  );
}
